// extracted by mini-css-extract-plugin
var _1 = "TeamIcon-module__animatedBackground--LT02P";
var _2 = "TeamIcon-module__large--WS4l8";
var _3 = "TeamIcon-module__medium--WFwJn";
var _4 = "TeamIcon-module__regular--qmrN_";
var _5 = "TeamIcon-module__small--f2PNE";
var _6 = "TeamIcon-module__teamIconDefault--Z_rk4";
var _7 = "TeamIcon-module__withBackground--B8Am5";
var _8 = "TeamIcon-module__xlarge--YARxs";
export { _1 as "animatedBackground", _2 as "large", _3 as "medium", _4 as "regular", _5 as "small", _6 as "teamIconDefault", _7 as "withBackground", _8 as "xlarge" }
